import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";

export default function WelcomePages({
  showButton = false,
  onAddResource,
  onOpenCategories,
  onOpenResourceTypes,
  viewMode = 'compact',
  onViewModeChange,
}: {
  showButton?: boolean;
  onAddResource?: () => void;
  onOpenCategories?: () => void;
  onOpenResourceTypes?: () => void;
  viewMode?: 'standard' | 'compact';
  onViewModeChange?: (viewMode: 'standard' | 'compact') => void;
}) {
  const { isAdmin } = useAuth();
  const { t } = useTranslation();
  
  return (
    <div className="flex flex-col lg:flex-row lg:items-center gap-6 mb-8">
      {/* Contenido principal */}
      <div className="flex-1">
        <h1 className="text-2xl lg:text-3xl font-bold text-[var(--text-default)] mb-2">
          {t('welcomePages.title')}
        </h1>
        <p className="text-[var(--text-muted)] text-base lg:text-lg leading-relaxed hidden md:block">
          {t('welcomePages.subtitle')}
        </p>
      </div>

      {/* Botones de acción (solo para admins) */}
      {showButton && isAdmin && (
        <div className="hidden md:flex flex-col sm:flex-row gap-3 lg:flex-shrink-0">
          {/* Selector de vista */}
          <button
            onClick={() => onViewModeChange?.(viewMode === 'compact' ? 'standard' : 'compact')}
            className="flex items-center justify-center px-4 py-3 bg-[var(--surface)] text-[var(--text-default)] border border-[var(--border)] font-medium rounded-lg hover:bg-[var(--border)] hover:text-[var(--surface)] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[var(--border)] focus:ring-offset-2 shadow-md"
            title={viewMode === 'compact' ? t('welcomePages.viewStandardTooltip') : t('welcomePages.viewCompactTooltip')}
          >
            <span className="material-icons text-lg mr-2">
              {viewMode === 'compact' ? 'view_module' : 'view_agenda'}
            </span>
            {viewMode === 'compact' ? t('welcomePages.viewStandard') : t('welcomePages.viewCompact')}
          </button>
          
          <button
            onClick={onOpenCategories}
            className="flex items-center justify-center px-4 py-3 bg-[var(--surface)] text-[var(--text-default)] border border-[var(--border)] font-medium rounded-lg hover:bg-[var(--border)] hover:text-[var(--surface)] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[var(--border)] focus:ring-offset-2 shadow-md"
          >
            <span className="material-icons text-lg mr-2">category</span>
            {t('welcomePages.categories')}
          </button>
          
          <button
            onClick={onOpenResourceTypes}
            className="flex items-center justify-center px-4 py-3 bg-[var(--surface)] text-[var(--text-default)] border border-[var(--border)] font-medium rounded-lg hover:bg-[var(--border)] hover:text-[var(--surface)] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[var(--border)] focus:ring-offset-2 shadow-md"
          >
            <span className="material-icons text-lg mr-2">article</span>
            {t('welcomePages.resourceTypes')}
          </button>
          
          <button
            onClick={onAddResource}
            className="flex items-center justify-center px-4 py-3 bg-[var(--surface)] text-[var(--text-default)] border border-[var(--border)] font-medium rounded-lg hover:bg-[var(--border)] hover:text-[var(--surface)] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[var(--border)] focus:ring-offset-2 shadow-md"
          >
            <span className="material-icons text-lg mr-2">add</span>
            {t('welcomePages.addResource')}
          </button>
        </div>
      )}
    </div>
  );
}
